//主页面
const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');
// 合作伙伴主数据
const logisticsStock = (r) =>
  require.ensure([], () => r(require('@/pages/reportCenter/logisticsStock.vue')), 'logisticsStock');
//提单清单
const ladingBillList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/reportCenter/ladingBillList/list.vue')),
    'ladingBillList'
  );
//销售总览
const salesOverview = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/reportCenter/salesOverview/list.vue')),
    'salesOverview'
  );
//实时凭证清单
const realTimeVoucher = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/reportCenter/realTimeVoucher/list.vue')),
    'realTimeVoucher'
  );
//采购总览
// const purchaseOverview = (r) =>
//   require.ensure(
//     [],
//     () => r(require('@/pages/reportCenter/purchaseOverview/list.vue')),
//     'purchaseOverview'
//   );
//进项税金明细表
const inputTaxDetails = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/reportCenter/inputTaxDetails/list.vue')),
    'inputTaxDetails'
  );
//销项税金明细表
const outputTaxDetails = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/reportCenter/outputTaxDetails/list.vue')),
    'outputTaxDetails'
  );

//逾期提醒
const overdueNotification = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/reportCenter/overdue/index.vue')),
    'outputTaxDetails'
  );

const reportCenter = {
  path: '/reportCenter',
  component: index,
  children: [
    {
      path: 'overdue',
      name: 'overdue',
      component: overdueNotification,
      meta: {
        keepAlive: true,
        title: '逾期提醒',
      },
    },
    {
      path: 'logisticsStock',
      name: 'logisticsStock',
      component: logisticsStock,
      meta: {
        keepAlive: true,
        title: '物流实时库存',
      },
    },
    {
      path: 'ladingBillList',
      name: 'ladingBillList',
      component: ladingBillList,
      meta: {
        keepAlive: true,
        title: '提单清单',
      },
    },
    {
      path: 'salesOverview',
      name: 'salesOverview',
      component: salesOverview,
      meta: {
        keepAlive: true,
        title: '销售总览',
      },
    },
    {
      path: 'realTimeVoucher',
      name: 'realTimeVoucher',
      component: realTimeVoucher,
      meta: {
        keepAlive: true,
        title: '实时凭证清单',
      },
    },
    // {
    //   path: 'purchaseOverview',
    //   name: 'purchaseOverview',
    //   component: () => import('@/pages/reportCenter/purchaseOverview/list.vue'),
    //   meta: {
    //     keepAlive: true,
    //     title: '采购总览',
    //   },
    // },
    {
      path: 'inputTaxDetails',
      name: 'inputTaxDetails',
      component: inputTaxDetails,
      meta: {
        keepAlive: true,
        title: '进项税金明细表',
      },
    },
    {
      path: 'outputTaxDetails',
      name: 'outputTaxDetails',
      component: outputTaxDetails,
      meta: {
        keepAlive: true,
        title: '销项税金明细表',
      },
    },
  ],
};
export default reportCenter;
